import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./ViewCompany.module.css"; // renamed CSS file for clarity
import EditCompanyCard from "./EditCompanyCard";
import DepartmentCard from "./ViewDepartmentCard";
import Wizard from "../../CompanyDashboard/CompanyContent/Wizard";


const ViewDepartment = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setIsLoading(true);
    setError("");

    try {
      const adminEmail = localStorage.getItem("adminemail");
      const response = await axios.post(
        "https://casaahaanahotels.com/sb_showcompanyusers",
        { adminemail: adminEmail }
      );

      if (response.data && response.data.user_data) {
        setCompanies(response.data.user_data);
      } else {
        setError("Failed to fetch companies. Please try again.");
      }
    } catch (err) {
      setError("Failed to fetch companies. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.vcContainer}>
    <Wizard currentStep={1} />
      <h1 className={styles.vcHeading}>All Companies</h1>
     
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className={styles.vcError}>{error}</p>
      ) : (
        <div className={styles.vcGrid}>
          {companies.map((company) => (
            <DepartmentCard
              key={company.id}
              companyName={company.companyname}
              adminName={`${company.admin_first_name} ${company.admin_last_name}`}
              adminEmail={company.adminemail}
              imageFile={company.imageFile}
              id={company.admincode}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewDepartment;
